import { ENTORNO } from "../utils/constantes";
import {
  getToken,
  getTokenNotificacion,
  getid,
} from "../utils/variablesLocales";

export class apiSubastador {
  baseApi = ENTORNO.BASE_API;

  async obtenerConductoresActivos() {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Subastador_ObtenerConductoresActivos}?role=Conductor&EstadoConductor=Activo`;

      const parametros = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      if (respuesta.status !== 200) throw respuestaJson;

      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }

  async ofrecerViajeAConductor() {
    try {
      //obtengo el proximo viaje en estado PENDIENTE
      const urlViaje = `${this.baseApi}/${ENTORNO.API_ROUTES.Viaje_ObtenerActivos}?Estado=PENDIENTE`;

      const parametrosViaje = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuestaViaje = await fetch(urlViaje, parametrosViaje);
      const respuestaJsonViaje = await respuestaViaje.json();

      if (respuestaViaje.status === 200) {
        if (respuestaJsonViaje.length > 0) {
          const Localidad = respuestaJsonViaje[0].Localidad;
          const IdViaje = respuestaJsonViaje[0]._id;
          const IdUsuario = respuestaJsonViaje[0].UsuarioId;

          const Partida = respuestaJsonViaje[0].PartidaDireccion;
          const Destino = respuestaJsonViaje[0].DestinoDireccion;
          const Kms = respuestaJsonViaje[0].Kms;
          const Min = respuestaJsonViaje[0].Min;
          const PrecioBase = respuestaJsonViaje[0].PrecioBase;
          const PrecioSugerido = respuestaJsonViaje[0].PrecioBase;
          const VerEnGoogleMaps = respuestaJsonViaje[0].VerEnGoogleMaps;
          const PartidaLatitud = respuestaJsonViaje[0].PartidaLatitud;
          const PartidaLongitud = respuestaJsonViaje[0].PartidaLongitud;
          const PartidaLocalidad = respuestaJsonViaje[0].Localidad;
          const PartidaProvincia = respuestaJsonViaje[0].Provincia;
          const DestinoLatitud = respuestaJsonViaje[0].DestinoLatitud;
          const DestinoLongitud = respuestaJsonViaje[0].DestinoLongitud;

          //obtengo el usuario del viaje
          const urlUsuarioViaje = `${this.baseApi}/${ENTORNO.API_ROUTES.Usuario_Obtener}?_id=${IdUsuario}`;

          const parametrosUsuarioViaje = {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${getToken()}`,
            },
          };

          const respuestaUsuarioViaje = await fetch(
            urlUsuarioViaje,
            parametrosUsuarioViaje
          );

          const respuestaJsonUsuarioViaje = await respuestaUsuarioViaje.json();

          if (respuestaJsonUsuarioViaje.length > 0) {
            const Pasajero =
              respuestaJsonUsuarioViaje[0].Nombre +
              " " +
              respuestaJsonUsuarioViaje[0].Apellido;

            //obtengo el conductor
            const urlConductor = `${this.baseApi}/${ENTORNO.API_ROUTES.Conductor_ObtenerDisponible}?role=Conductor&active=true&EstadoConductor=Activo&Viaje_Pasajero=Disponible&Localidad=${Localidad}`;

            const parametrosConductor = {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${getToken()}`,
              },
            };

            const respuestaConductor = await fetch(
              urlConductor,
              parametrosConductor
            );

            const respuestaJsonConductor = await respuestaConductor.json();

            if (respuestaJsonConductor.length > 0) {
              const Id = respuestaJsonConductor[0]._id;

              //actualizar datos del viaje en conductor
              const urlConductorActualizarViaje = `${this.baseApi}/${ENTORNO.API_ROUTES.Usuario_Actualizar}/${Id}`;

              const parametrosConductorActualizarViaje = {
                method: "PATCH",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${getToken()}`,
                },
                body: JSON.stringify({
                  Viaje_IdViaje: IdViaje,
                  Viaje_Pasajero: Pasajero,
                  Viaje_Estado: "PENDIENTE DE ACEPTAR VIAJE",
                  Viaje_Partida: Partida,
                  Viaje_Destino: Destino,
                  Viaje_Min: Min,
                  Viaje_Kms: Kms,
                  Viaje_PrecioBase: PrecioBase,
                  Viaje_PrecioSugerido: PrecioSugerido,
                  Viaje_VerEnGoogleMaps: VerEnGoogleMaps,
                  Viaje_PartidaLatitud: PartidaLatitud,
                  Viaje_PartidaLongitud: PartidaLongitud,
                  Viaje_UbicacionVehiculoLatitud: "",
                  Viaje_UbicacionVehiculoLongitud: "",
                  Viaje_MinLlegadaABuscarPasajero: "",
                  Viaje_VerEnGoogleMapsRutaBusquedaPasajero: "",
                  Viaje_UbicacionAlBuscarPasajeroLatitud: "",
                  Viaje_UbicacionAlBuscarPasajeroLongitud: "",
                  Viaje_MetrosDistanciaEntreVehiculoYPasajero: 0,
                  Viaje_PartidaLocalidad: PartidaLocalidad,
                  Viaje_PartidaProvincia: PartidaProvincia,
                  Viaje_DestinoLatitud: DestinoLatitud,
                  Viaje_DestinoLongitud: DestinoLongitud,
                  Viaje_Saldo: PrecioBase,
                }),
              };

              const respuestaConductorActualizarViaje = await fetch(
                urlConductorActualizarViaje,
                parametrosConductorActualizarViaje
              );

              return respuestaConductorActualizarViaje;
            }
          }
        }
      }
    } catch (error) {
      throw error;
    }
  }

  async obtenerConductor() {
    try {
      const url = `${this.baseApi}/${
        ENTORNO.API_ROUTES.Subastador_ObtenerConductoresActivos
      }?_id=${getid()}`;

      const parametros = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      if (respuesta.status !== 200) throw respuestaJson;

      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }

  async subastar(ViajeId) {
    try {
      const url = this.baseApi + "/" + ENTORNO.API_ROUTES.Subastador_subastar;

      const parametros = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          ViajeId: ViajeId,
        }),
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }

  async aceptarViaje(
    ViajeId,
    ChoferId,
    Pasajero,
    Partida,
    Destino,
    Min,
    Kms,
    PrecioBase,
    PrecioSugerido,
    VerEnGoogleMaps,
    PartidaLatitud,
    PartidaLongitud,
    PartidaLocalidad,
    PartidaProvincia,
    DestinoLatitud,
    DestinoLongitud
  ) {
    try {
      //obtener datos de chofer
      const urlConductor0 = `${this.baseApi}/${ENTORNO.API_ROUTES.Conductor_ObtenerDisponible}?_id=${ChoferId}`;

      const parametrosConductor0 = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuestaConductor0 = await fetch(
        urlConductor0,
        parametrosConductor0
      );

      const respuestaJsonConductor0 = await respuestaConductor0.json();

      if (respuestaJsonConductor0.length > 0) {
        const Chofer =
          respuestaJsonConductor0[0].Nombre +
          " " +
          respuestaJsonConductor0[0].Apellido;
        const Marca = respuestaJsonConductor0[0].Vehiculo_Marca;
        const Modelo = respuestaJsonConductor0[0].Vehiculo_Modelo;
        const Color = respuestaJsonConductor0[0].Vehiculo_Color;
        const Dominio = respuestaJsonConductor0[0].Vehiculo_Dominio;

        //cambiar estado en usuario.viaje a PENDIENTE
        const urlConductor = `${this.baseApi}/${ENTORNO.API_ROUTES.Usuario_Actualizar}/${ChoferId}`;

        const parametrosConductor = {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
          body: JSON.stringify({
            Viaje_IdViaje: ViajeId,
            Viaje_Pasajero: Pasajero,
            Viaje_Estado: "CONDUCTOR ASIGNADO",
            Viaje_Partida: Partida,
            Viaje_Destino: Destino,
            Viaje_Min: Min,
            Viaje_Kms: Kms,
            Viaje_PrecioBase: PrecioBase,
            Viaje_PrecioSugerido: PrecioSugerido,
            Viaje_VerEnGoogleMaps: VerEnGoogleMaps,
            Viaje_PartidaLatitud: PartidaLatitud,
            Viaje_PartidaLongitud: PartidaLongitud,
            Viaje_UbicacionVehiculoLatitud: "",
            Viaje_UbicacionVehiculoLongitud: "",
            Viaje_MinLlegadaABuscarPasajero: "",
            Viaje_VerEnGoogleMapsRutaBusquedaPasajero: "",
            Viaje_UbicacionAlBuscarPasajeroLatitud: "",
            Viaje_UbicacionAlBuscarPasajeroLongitud: "",
            Viaje_MetrosDistanciaEntreVehiculoYPasajero: 0,
            Viaje_PartidaLocalidad: PartidaLocalidad,
            Viaje_PartidaProvincia: PartidaProvincia,
            Viaje_DestinoLatitud: DestinoLatitud,
            Viaje_DestinoLongitud: DestinoLongitud,
            Viaje_Saldo: PrecioBase,
          }),
        };

        const respuestaConductor = await fetch(
          urlConductor,
          parametrosConductor
        );

        await respuestaConductor.json();

        //actualizar viaje
        const urlViaje = `${this.baseApi}/${ENTORNO.API_ROUTES.Viaje_Actualizar}/${ViajeId}`;

        const parametrosViaje = {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
          body: JSON.stringify({
            Estado: "CONDUCTOR ASIGNADO",
            ChoferId: ChoferId,
            Chofer: Chofer,
            Marca: Marca,
            Modelo: Modelo,
            Color: Color,
            Dominio: Dominio,
            PrecioSugerido: PrecioSugerido,
            UbicacionVehiculoLatitud: "",
            UbicacionVehiculoLongitud: "",
            MinLlegadaABuscarPasajero: "",
            VerEnGoogleMapsRutaBusquedaPasajero: "",
            UbicacionAlBuscarPasajeroLatitud: "",
            UbicacionAlBuscarPasajeroLongitud: "",
            MetrosDistanciaEntreVehiculoYPasajero: 0,
            Mobbex_Pago_Id: "",
            Mobbex_Pago_Fecha: "",
          }),
        };

        await fetch(urlViaje, parametrosViaje);
      }
    } catch (error) {
      throw error;
    }
  }

  async noaceptarviaje(ViajeId, UsuarioId) {
    try {
      //obtener datos de chofer
      const urlConductor0 = `${this.baseApi}/${ENTORNO.API_ROUTES.Conductor_ObtenerDisponible}?_id=${UsuarioId}`;

      const parametrosConductor0 = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuestaConductor0 = await fetch(
        urlConductor0,
        parametrosConductor0
      );

      const respuestaJsonConductor0 = await respuestaConductor0.json();

      if (respuestaJsonConductor0.length > 0) {
        //cambiar estado en usuario.viaje a PENDIENTE
        const urlConductor = `${this.baseApi}/${ENTORNO.API_ROUTES.Usuario_Actualizar}/${UsuarioId}`;

        const parametrosConductor = {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
          body: JSON.stringify({
            Viaje_IdViaje: "",
            Viaje_Pasajero: "Disponible",
            Viaje_Estado: "",
            Viaje_Partida: "",
            Viaje_Destino: "",
            Viaje_Min: "",
            Viaje_Kms: "",
            Viaje_PrecioBase: 0,
            Viaje_PrecioSugerido: 0,
            Viaje_VerEnGoogleMaps: "",
            Viaje_PartidaLatitud: "",
            Viaje_PartidaLongitud: "",
            Viaje_UbicacionVehiculoLatitud: "",
            Viaje_UbicacionVehiculoLongitud: "",
            Viaje_MinLlegadaABuscarPasajero: "",
            Viaje_VerEnGoogleMapsRutaBusquedaPasajero: "",
            Viaje_UbicacionAlBuscarPasajeroLatitud: "",
            Viaje_UbicacionAlBuscarPasajeroLongitud: "",
            Viaje_MetrosDistanciaEntreVehiculoYPasajero: 0,
            Viaje_PartidaLocalidad: "",
            Viaje_PartidaProvincia: "",
            Viaje_DestinoLatitud: "",
            Viaje_DestinoLongitud: "",
            Viaje_Saldo: 0,
          }),
        };

        const respuestaConductor = await fetch(
          urlConductor,
          parametrosConductor
        );

        const respuestaJsonConductor = await respuestaConductor.json();

        if (respuestaJsonConductor.length > 0) {
          //actualizar viaje
          const urlViaje = `${this.baseApi}/${ENTORNO.API_ROUTES.Viaje_Actualizar}/${ViajeId}`;

          const parametrosViaje = {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${getToken()}`,
            },
            body: JSON.stringify({
              Estado: "PENDIENTE",
              ChoferId: "",
              Chofer: "",
              Marca: "",
              Modelo: "",
              Color: "",
              Dominio: "",
              PrecioSugerido: 0,
              UbicacionVehiculoLatitud: "",
              UbicacionVehiculoLongitud: "",
              MinLlegadaABuscarPasajero: "",
              VerEnGoogleMapsRutaBusquedaPasajero: "",
              UbicacionAlBuscarPasajeroLatitud: "",
              UbicacionAlBuscarPasajeroLongitud: "",
              MetrosDistanciaEntreVehiculoYPasajero: 0,
              Mobbex_Pago_Id: "",
              Mobbex_Pago_Fecha: "",
            }),
          };

          await fetch(urlViaje, parametrosViaje);
        }
      }
    } catch (error) {
      throw error;
    }
  }

  async levantarPasajero(ViajeId, UsuarioId) {
    try {
      //obtener datos de chofer
      const urlConductor0 = `${this.baseApi}/${ENTORNO.API_ROUTES.Conductor_ObtenerDisponible}?_id=${UsuarioId}`;

      const parametrosConductor0 = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuestaConductor0 = await fetch(
        urlConductor0,
        parametrosConductor0
      );

      const respuestaJsonConductor0 = await respuestaConductor0.json();

      if (respuestaJsonConductor0.length > 0) {
        const ChoferId = respuestaJsonConductor0[0]._id;
        const Chofer =
          respuestaJsonConductor0[0].Nombre +
          " " +
          respuestaJsonConductor0[0].Apellido;
        const Marca = respuestaJsonConductor0[0].Vehiculo_Marca;
        const Modelo = respuestaJsonConductor0[0].Vehiculo_Modelo;
        const Color = respuestaJsonConductor0[0].Vehiculo_Color;
        const Dominio = respuestaJsonConductor0[0].Vehiculo_Dominio;
        const PrecioBase = respuestaJsonConductor0[0].Viaje_PrecioBase;
        const PrecioSugerido = respuestaJsonConductor0[0].Viaje_PrecioSugerido;
        const IdViaje = respuestaJsonConductor0[0].Viaje_IdViaje;
        const Pasajero = respuestaJsonConductor0[0].Viaje_Pasajero;
        const Partida = respuestaJsonConductor0[0].Viaje_Partida;
        const Destino = respuestaJsonConductor0[0].Viaje_Destino;
        const Min = respuestaJsonConductor0[0].Viaje_Min;
        const Kms = respuestaJsonConductor0[0].Viaje_Kms;

        const VerEnGoogleMaps =
          respuestaJsonConductor0[0].Viaje_VerEnGoogleMaps;
        const PartidaLatitud = respuestaJsonConductor0[0].Viaje_PartidaLatitud;
        const PartidaLongitud =
          respuestaJsonConductor0[0].Viaje_PartidaLongitud;
        const UbicacionVehiculoLatitud =
          respuestaJsonConductor0[0].Viaje_UbicacionVehiculoLatitud;
        const UbicacionVehiculoLongitud =
          respuestaJsonConductor0[0].Viaje_UbicacionVehiculoLongitud;
        const MinLlegadaABuscarPasajero =
          respuestaJsonConductor0[0].Viaje_MinLlegadaABuscarPasajero;
        const VerEnGoogleMapsRutaBusquedaPasajero =
          respuestaJsonConductor0[0].Viaje_VerEnGoogleMapsRutaBusquedaPasajero;
        const UbicacionAlBuscarPasajeroLatitud =
          respuestaJsonConductor0[0].Viaje_UbicacionAlBuscarPasajeroLatitud;
        const UbicacionAlBuscarPasajeroLongitud =
          respuestaJsonConductor0[0].Viaje_UbicacionAlBuscarPasajeroLongitud;
        const MetrosDistanciaEntreVehiculoYPasajero =
          respuestaJsonConductor0[0]
            .Viaje_MetrosDistanciaEntreVehiculoYPasajero;
        const PartidaLocalidad =
          respuestaJsonConductor0[0].Viaje_PartidaLocalidad;
        const PartidaProvincia =
          respuestaJsonConductor0[0].Viaje_PartidaProvincia;
        const DestinoLatitud = respuestaJsonConductor0[0].Viaje_DestinoLatitud;
        const DestinoLongitud =
          respuestaJsonConductor0[0].Viaje_DestinoLongitud;

        //cambiar estado en usuario.viaje a EN CURSO
        const urlConductor = `${this.baseApi}/${ENTORNO.API_ROUTES.Usuario_Actualizar}/${UsuarioId}`;

        const parametrosConductor = {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
          body: JSON.stringify({
            Viaje_IdViaje: IdViaje,
            Viaje_Pasajero: Pasajero,
            Viaje_Estado: "EN CURSO",
            Viaje_Partida: Partida,
            Viaje_Destino: Destino,
            Viaje_Min: Min,
            Viaje_Kms: Kms,
            Viaje_PrecioBase: PrecioBase,
            Viaje_PrecioSugerido: PrecioSugerido,
            Viaje_VerEnGoogleMaps: VerEnGoogleMaps,
            Viaje_PartidaLatitud: PartidaLatitud,
            Viaje_PartidaLongitud: PartidaLongitud,
            Viaje_UbicacionVehiculoLatitud: UbicacionVehiculoLatitud,
            Viaje_UbicacionVehiculoLongitud: UbicacionVehiculoLongitud,
            Viaje_MinLlegadaABuscarPasajero: MinLlegadaABuscarPasajero,
            Viaje_VerEnGoogleMapsRutaBusquedaPasajero:
              VerEnGoogleMapsRutaBusquedaPasajero,
            Viaje_UbicacionAlBuscarPasajeroLatitud:
              UbicacionAlBuscarPasajeroLatitud,
            Viaje_UbicacionAlBuscarPasajeroLongitud:
              UbicacionAlBuscarPasajeroLongitud,
            Viaje_MetrosDistanciaEntreVehiculoYPasajero:
              MetrosDistanciaEntreVehiculoYPasajero,
            Viaje_PartidaLocalidad: PartidaLocalidad,
            Viaje_PartidaProvincia: PartidaProvincia,
            Viaje_DestinoLatitud: DestinoLatitud,
            Viaje_DestinoLongitud: DestinoLongitud,
          }),
        };

        const respuestaConductor = await fetch(
          urlConductor,
          parametrosConductor
        );

        await respuestaConductor.json();

        //actualizar viaje
        const urlViaje = `${this.baseApi}/${ENTORNO.API_ROUTES.Viaje_Actualizar}/${ViajeId}`;

        const parametrosViaje = {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
          body: JSON.stringify({
            Estado: "EN CURSO",
            ChoferId: ChoferId,
            Chofer: Chofer,
            Marca: Marca,
            Modelo: Modelo,
            Color: Color,
            Dominio: Dominio,
          }),
        };

        await fetch(urlViaje, parametrosViaje);
      }
    } catch (error) {
      throw error;
    }
  }

  async finalizarViaje(ViajeId, ChoferId) {
    try {
      //obtener datos de chofer
      const urlConductor0 = `${this.baseApi}/${ENTORNO.API_ROUTES.Conductor_ObtenerDisponible}?_id=${ChoferId}`;

      const parametrosConductor0 = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuestaConductor0 = await fetch(
        urlConductor0,
        parametrosConductor0
      );

      const respuestaJsonConductor0 = await respuestaConductor0.json();

      if (respuestaJsonConductor0.length > 0) {
        const PrecioBase = respuestaJsonConductor0[0].Viaje_PrecioBase;
        const PrecioSugerido = respuestaJsonConductor0[0].Viaje_PrecioSugerido;
        const IdViaje = respuestaJsonConductor0[0].Viaje_IdViaje;
        const Pasajero = respuestaJsonConductor0[0].Viaje_Pasajero;
        const Partida = respuestaJsonConductor0[0].Viaje_Partida;
        const Destino = respuestaJsonConductor0[0].Viaje_Destino;
        const Min = respuestaJsonConductor0[0].Viaje_Min;
        const Kms = respuestaJsonConductor0[0].Viaje_Kms;

        const VerEnGoogleMaps =
          respuestaJsonConductor0[0].Viaje_VerEnGoogleMaps;
        const PartidaLatitud = respuestaJsonConductor0[0].Viaje_PartidaLatitud;
        const PartidaLongitud =
          respuestaJsonConductor0[0].Viaje_PartidaLongitud;
        // const UbicacionAlBuscarPasajeroLatitud =
        //   respuestaJsonConductor0[0].Viaje_UbicacionAlBuscarPasajeroLatitud;
        // const UbicacionAlBuscarPasajeroLongitud =
        //   respuestaJsonConductor0[0].Viaje_UbicacionAlBuscarPasajeroLongitud;
        // const MetrosDistanciaEntreVehiculoYPasajero =
        //   respuestaJsonConductor0[0]
        //     .Viaje_MetrosDistanciaEntreVehiculoYPasajero;
        const PartidaLocalidad =
          respuestaJsonConductor0[0].Viaje_PartidaLocalidad;
        const PartidaProvincia =
          respuestaJsonConductor0[0].Viaje_PartidaProvincia;

        const UbicacionVehiculoLatitud =
          respuestaJsonConductor0[0].Viaje_UbicacionVehiculoLatitud;
        const UbicacionVehiculoLongitud =
          respuestaJsonConductor0[0].Viaje_UbicacionVehiculoLongitud;
        const MinLlegadaABuscarPasajero =
          respuestaJsonConductor0[0].Viaje_MinLlegadaABuscarPasajero;
        const VerEnGoogleMapsRutaBusquedaPasajero =
          respuestaJsonConductor0[0].Viaje_VerEnGoogleMapsRutaBusquedaPasajero;
        const DestinoLatitud = respuestaJsonConductor0[0].Viaje_DestinoLatitud;
        const DestinoLongitud =
          respuestaJsonConductor0[0].Viaje_DestinoLongitud;

        //cambiar estado en usuario.viaje a PENDIENTE
        const urlConductor = `${this.baseApi}/${ENTORNO.API_ROUTES.Usuario_Actualizar}/${ChoferId}`;

        const parametrosConductor = {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
          body: JSON.stringify({
            Viaje_IdViaje: IdViaje,
            Viaje_Pasajero: Pasajero,
            Viaje_Estado: "FINALIZADO",
            Viaje_Partida: Partida,
            Viaje_Destino: Destino,
            Viaje_Min: Min,
            Viaje_Kms: Kms,
            Viaje_PrecioBase: PrecioBase,
            Viaje_PrecioSugerido: PrecioSugerido,
            Viaje_VerEnGoogleMaps: VerEnGoogleMaps,
            Viaje_PartidaLatitud: PartidaLatitud,
            Viaje_PartidaLongitud: PartidaLongitud,
            Viaje_UbicacionVehiculoLatitud: UbicacionVehiculoLatitud,
            Viaje_UbicacionVehiculoLongitud: UbicacionVehiculoLongitud,
            Viaje_MinLlegadaABuscarPasajero: MinLlegadaABuscarPasajero,
            Viaje_VerEnGoogleMapsRutaBusquedaPasajero:
              VerEnGoogleMapsRutaBusquedaPasajero,
            Viaje_UbicacionAlBuscarPasajeroLatitud: "",
            Viaje_UbicacionAlBuscarPasajeroLongitud: "",
            Viaje_MetrosDistanciaEntreVehiculoYPasajero: "",
            Viaje_PartidaLocalidad: PartidaLocalidad,
            Viaje_PartidaProvincia: PartidaProvincia,
            Viaje_DestinoLatitud: DestinoLatitud,
            Viaje_DestinoLongitud: DestinoLongitud,
          }),
        };

        const respuestaConductor = await fetch(
          urlConductor,
          parametrosConductor
        );

        await respuestaConductor.json();

        //actualizar viaje
        const urlViaje = `${this.baseApi}/${ENTORNO.API_ROUTES.Viaje_Actualizar}/${ViajeId}`;

        const parametrosViaje = {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
          body: JSON.stringify({
            Estado: "FINALIZADO",
          }),
        };

        await fetch(urlViaje, parametrosViaje);
      }
    } catch (error) {
      throw error;
    }
  }

  async activarRutaDeViaje(
    ViajeId,
    ChoferId,
    UbicacionVehiculoLatitud,
    UbicacionVehiculoLongitud,
    MinLlegadaABuscarPasajero,
    VerEnGoogleMapsRutaBusquedaPasajero
  ) {
    try {
      //obtener datos de chofer
      const urlConductor0 = `${this.baseApi}/${ENTORNO.API_ROUTES.Conductor_ObtenerDisponible}?_id=${ChoferId}`;

      const parametrosConductor0 = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuestaConductor0 = await fetch(
        urlConductor0,
        parametrosConductor0
      );

      const respuestaJsonConductor0 = await respuestaConductor0.json();

      if (respuestaJsonConductor0.length > 0) {
        const PrecioBase = respuestaJsonConductor0[0].Viaje_PrecioBase;
        const PrecioSugerido = respuestaJsonConductor0[0].Viaje_PrecioSugerido;
        const IdViaje = respuestaJsonConductor0[0].Viaje_IdViaje;
        const Pasajero = respuestaJsonConductor0[0].Viaje_Pasajero;
        const Partida = respuestaJsonConductor0[0].Viaje_Partida;
        const Destino = respuestaJsonConductor0[0].Viaje_Destino;
        const Min = respuestaJsonConductor0[0].Viaje_Min;
        const Kms = respuestaJsonConductor0[0].Viaje_Kms;

        const VerEnGoogleMaps =
          respuestaJsonConductor0[0].Viaje_VerEnGoogleMaps;
        const PartidaLatitud = respuestaJsonConductor0[0].Viaje_PartidaLatitud;
        const PartidaLongitud =
          respuestaJsonConductor0[0].Viaje_PartidaLongitud;
        const UbicacionAlBuscarPasajeroLatitud =
          respuestaJsonConductor0[0].Viaje_UbicacionAlBuscarPasajeroLatitud;
        const UbicacionAlBuscarPasajeroLongitud =
          respuestaJsonConductor0[0].Viaje_UbicacionAlBuscarPasajeroLongitud;
        const MetrosDistanciaEntreVehiculoYPasajero =
          respuestaJsonConductor0[0]
            .Viaje_MetrosDistanciaEntreVehiculoYPasajero;
        const PartidaLocalidad =
          respuestaJsonConductor0[0].Viaje_PartidaLocalidad;
        const PartidaProvincia =
          respuestaJsonConductor0[0].Viaje_PartidaProvincia;
        const DestinoLatitud = respuestaJsonConductor0[0].Viaje_DestinoLatitud;
        const DestinoLongitud =
          respuestaJsonConductor0[0].Viaje_DestinoLongitud;

        //cambiar estado en usuario.viaje a PENDIENTE
        const urlConductor = `${this.baseApi}/${ENTORNO.API_ROUTES.Usuario_Actualizar}/${ChoferId}`;

        const parametrosConductor = {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
          body: JSON.stringify({
            Viaje_IdViaje: IdViaje,
            Viaje_Pasajero: Pasajero,
            Viaje_Estado: "RUTA DE VIAJE ACTIVADA",
            Viaje_Partida: Partida,
            Viaje_Destino: Destino,
            Viaje_Min: Min,
            Viaje_Kms: Kms,
            Viaje_PrecioBase: PrecioBase,
            Viaje_PrecioSugerido: PrecioSugerido,
            Viaje_VerEnGoogleMaps: VerEnGoogleMaps,
            Viaje_PartidaLatitud: PartidaLatitud,
            Viaje_PartidaLongitud: PartidaLongitud,
            Viaje_UbicacionVehiculoLatitud: UbicacionVehiculoLatitud,
            Viaje_UbicacionVehiculoLongitud: UbicacionVehiculoLongitud,
            Viaje_MinLlegadaABuscarPasajero: MinLlegadaABuscarPasajero,
            Viaje_VerEnGoogleMapsRutaBusquedaPasajero:
              VerEnGoogleMapsRutaBusquedaPasajero,
            Viaje_UbicacionAlBuscarPasajeroLatitud:
              UbicacionAlBuscarPasajeroLatitud,
            Viaje_UbicacionAlBuscarPasajeroLongitud:
              UbicacionAlBuscarPasajeroLongitud,
            Viaje_MetrosDistanciaEntreVehiculoYPasajero:
              MetrosDistanciaEntreVehiculoYPasajero,
            Viaje_PartidaLocalidad: PartidaLocalidad,
            Viaje_PartidaProvincia: PartidaProvincia,
            Viaje_DestinoLatitud: DestinoLatitud,
            Viaje_DestinoLongitud: DestinoLongitud,
          }),
        };

        const respuestaConductor = await fetch(
          urlConductor,
          parametrosConductor
        );

        await respuestaConductor.json();

        //actualizar viaje
        const urlViaje = `${this.baseApi}/${ENTORNO.API_ROUTES.Viaje_Actualizar}/${ViajeId}`;

        const parametrosViaje = {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
          body: JSON.stringify({
            Estado: "RUTA DE VIAJE ACTIVADA",
            UbicacionVehiculoLatitud: UbicacionVehiculoLatitud,
            UbicacionVehiculoLongitud: UbicacionVehiculoLongitud,
            MinLlegadaABuscarPasajero: MinLlegadaABuscarPasajero,
            VerEnGoogleMapsRutaBusquedaPasajero:
              VerEnGoogleMapsRutaBusquedaPasajero,
          }),
        };

        await fetch(urlViaje, parametrosViaje);
      }
    } catch (error) {
      throw error;
    }
  }

  async activarTransito(ViajeId, ChoferId) {
    try {
      //obtener datos de chofer
      const urlConductor0 = `${this.baseApi}/${ENTORNO.API_ROUTES.Conductor_ObtenerDisponible}?_id=${ChoferId}`;

      const parametrosConductor0 = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuestaConductor0 = await fetch(
        urlConductor0,
        parametrosConductor0
      );

      const respuestaJsonConductor0 = await respuestaConductor0.json();

      if (respuestaJsonConductor0.length > 0) {
        const PrecioBase = respuestaJsonConductor0[0].Viaje_PrecioBase;
        const PrecioSugerido = respuestaJsonConductor0[0].Viaje_PrecioSugerido;
        const IdViaje = respuestaJsonConductor0[0].Viaje_IdViaje;
        const Pasajero = respuestaJsonConductor0[0].Viaje_Pasajero;
        const Partida = respuestaJsonConductor0[0].Viaje_Partida;
        const Destino = respuestaJsonConductor0[0].Viaje_Destino;
        const Min = respuestaJsonConductor0[0].Viaje_Min;
        const Kms = respuestaJsonConductor0[0].Viaje_Kms;

        const VerEnGoogleMaps =
          respuestaJsonConductor0[0].Viaje_VerEnGoogleMaps;
        const PartidaLatitud = respuestaJsonConductor0[0].Viaje_PartidaLatitud;
        const PartidaLongitud =
          respuestaJsonConductor0[0].Viaje_PartidaLongitud;
        // const UbicacionAlBuscarPasajeroLatitud =
        //   respuestaJsonConductor0[0].Viaje_UbicacionAlBuscarPasajeroLatitud;
        // const UbicacionAlBuscarPasajeroLongitud =
        //   respuestaJsonConductor0[0].Viaje_UbicacionAlBuscarPasajeroLongitud;
        // const MetrosDistanciaEntreVehiculoYPasajero =
        //   respuestaJsonConductor0[0]
        //     .Viaje_MetrosDistanciaEntreVehiculoYPasajero;
        const PartidaLocalidad =
          respuestaJsonConductor0[0].Viaje_PartidaLocalidad;
        const PartidaProvincia =
          respuestaJsonConductor0[0].Viaje_PartidaProvincia;

        const UbicacionVehiculoLatitud =
          respuestaJsonConductor0[0].Viaje_UbicacionVehiculoLatitud;
        const UbicacionVehiculoLongitud =
          respuestaJsonConductor0[0].Viaje_UbicacionVehiculoLongitud;
        const MinLlegadaABuscarPasajero =
          respuestaJsonConductor0[0].Viaje_MinLlegadaABuscarPasajero;
        const VerEnGoogleMapsRutaBusquedaPasajero =
          respuestaJsonConductor0[0].Viaje_VerEnGoogleMapsRutaBusquedaPasajero;
        const DestinoLatitud = respuestaJsonConductor0[0].Viaje_DestinoLatitud;
        const DestinoLongitud =
          respuestaJsonConductor0[0].Viaje_DestinoLongitud;

        //cambiar estado en usuario.viaje a PENDIENTE
        const urlConductor = `${this.baseApi}/${ENTORNO.API_ROUTES.Usuario_Actualizar}/${ChoferId}`;

        const parametrosConductor = {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
          body: JSON.stringify({
            Viaje_IdViaje: IdViaje,
            Viaje_Pasajero: Pasajero,
            Viaje_Estado: "TRANSITO ACTIVADO",
            Viaje_Partida: Partida,
            Viaje_Destino: Destino,
            Viaje_Min: Min,
            Viaje_Kms: Kms,
            Viaje_PrecioBase: PrecioBase,
            Viaje_PrecioSugerido: PrecioSugerido,
            Viaje_VerEnGoogleMaps: VerEnGoogleMaps,
            Viaje_PartidaLatitud: PartidaLatitud,
            Viaje_PartidaLongitud: PartidaLongitud,
            Viaje_UbicacionVehiculoLatitud: UbicacionVehiculoLatitud,
            Viaje_UbicacionVehiculoLongitud: UbicacionVehiculoLongitud,
            Viaje_MinLlegadaABuscarPasajero: MinLlegadaABuscarPasajero,
            Viaje_VerEnGoogleMapsRutaBusquedaPasajero:
              VerEnGoogleMapsRutaBusquedaPasajero,
            Viaje_UbicacionAlBuscarPasajeroLatitud: "",
            Viaje_UbicacionAlBuscarPasajeroLongitud: "",
            Viaje_MetrosDistanciaEntreVehiculoYPasajero: "",
            Viaje_PartidaLocalidad: PartidaLocalidad,
            Viaje_PartidaProvincia: PartidaProvincia,
            Viaje_DestinoLatitud: DestinoLatitud,
            Viaje_DestinoLongitud: DestinoLongitud,
          }),
        };

        const respuestaConductor = await fetch(
          urlConductor,
          parametrosConductor
        );

        await respuestaConductor.json();

        //actualizar viaje
        const urlViaje = `${this.baseApi}/${ENTORNO.API_ROUTES.Viaje_Actualizar}/${ViajeId}`;

        const parametrosViaje = {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
          body: JSON.stringify({
            Estado: "TRANSITO ACTIVADO",
          }),
        };

        await fetch(urlViaje, parametrosViaje);
      }
    } catch (error) {
      throw error;
    }
  }
}
